module.exports = __webpack_public_path__ + "src/routes/whyhostnew/whyhostbanner.jpg?01b44601";


//////////////////
// WEBPACK FOOTER
// ./src/routes/whyhostnew/whyhostbanner.jpg
// module id = 3143
// module chunks = 8